import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ReactDOM from 'react-dom';
import { Icon, Dropdown, Menu, Popup } from 'semantic-ui-react';
import { fetchInTimeOptionEnd, fetchInTimeOptionStart } from '../../../../businessLogic/operatingDaysAndHours';
import { downloadPILFile } from 'actions/waitingArea';
import { showShareByEmailModal, showShareByTextModal } from 'actions/modal';
import TooltipMessage from '../../../helpers/tooltipMessage.js';
import BottomAccordion from '../../../shared/bottom-accordion/content';
import { displayGlobalMessage } from 'actions/globalMessage';
import { getWAURLEmailTemplate, getWAURLTextTemplate } from 'actions/waitingArea';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
import HtmlToReact from 'html-to-react';
import copy from 'copy-to-clipboard';

import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function Accordion(props) {
  const dispatch = useDispatch();
  const [isPILDownloadButtonEnabled, setIsPILDownloadButtonEnabled] = useState(true);
  const [extendContent, setExtendContent] = useState(false);

  // For waiting area hours
  const getDayNames = ({
    isMondaySelected,
    isTuesdaySelected,
    isWednesdaySelected,
    isThursdaySelected,
    isFridaySelected,
    isSaturdaySelected,
    isSundaySelected,
  }) => {
    let dayNames = [];

    isMondaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.MondayText) : '';
    isTuesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.TuesdayText) : '';
    isWednesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.WednesdayText) : '';
    isThursdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.ThursdayText) : '';
    isFridaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.FridayText) : '';
    isSaturdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.SaturdayText) : '';
    isSundaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.SundayText) : '';
    return dayNames.join(', ');
  };
  const getShortDayNames = ({
    isMondaySelected,
    isTuesdaySelected,
    isWednesdaySelected,
    isThursdaySelected,
    isFridaySelected,
    isSaturdaySelected,
    isSundaySelected,
  }) => {
    let dayNames = [];

    isMondaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.MondayShort) : '';
    isTuesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.TuesdayShort) : '';
    isWednesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.WednesdayShort) : '';
    isThursdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.ThursdayShort) : '';
    isFridaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.FridayShort) : '';
    isSaturdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.SaturdayShort) : '';
    isSundaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.SundayShort) : '';
    return dayNames.join(', ');
  };

  const getTimeZoneText = () => {
    if (props.timezones && props.timezones.length > 0 && !!props.waitingArea.operatingHours) {
      const timeZone = props.timezones.find((x) => x.value == props.waitingArea.operatingHours.serviceTimeZone);
      if (timeZone) return timeZone.text;
      return props.waitingArea.operatingHours.serviceTimeZone;
    } else {
      return '';
    }
  };

  const generateWAhoursMarkUp = () => {
    let serviceTimeZone = getTimeZoneText();
    let serviceAvailabilitiesArray = [];
    if (!!props.waitingArea.operatingHours) {
      props.waitingArea.operatingHours.serviceOfferingAvailabilities.map((availability, i) => {
        let serviceAvailability = {
          serviceAvailalableHours:
            fetchInTimeOptionStart(availability.fromTime) + ' to ' + fetchInTimeOptionEnd(availability.toTime),
          serviceAvailalableDays: getDayNames(availability),
          serviceAvailalableShortDays: getShortDayNames(availability),
        };
        serviceAvailabilitiesArray.push(serviceAvailability);
      });
    }
    return (
      <div>
        {serviceAvailabilitiesArray.map((thisServiceAvailability, i) => {
          return (
            <div key={i}>
              <div>{thisServiceAvailability.serviceAvailalableHours}</div>
              <div className="hide-on-small-ress">{thisServiceAvailability.serviceAvailalableDays}</div>
              <div className="show-on-small-ress">{thisServiceAvailability.serviceAvailalableShortDays}</div>
              <p>
                <br />
              </p>
            </div>
          );
        })}
        <p>{serviceTimeZone}</p>
      </div>
    );
  };

  const generatePILDownloadButton = () => {
    return (
      <div>
        <button
          type="button"
          disabled={!isPILDownloadButtonEnabled}
          className="ui labeled icon button right-hand-side-button"
          id="download-pil-rhs"
          onClick={() => {
            setIsPILDownloadButtonEnabled(false);
            downloadPILFile(props.waitingArea.id, () => {
              setIsPILDownloadButtonEnabled(true);
            });
          }}
        >
          <i className="download icon" />
          {APP.LANGUAGE.ViewOneWaitingArea.DownloadPIL}
        </button>
      </div>
    );
  };

  const generateSupportContactDetail = () => {
    let supportName = '';
    let supportEmail = '';
    let supportPhone = '';
    let supportWebsite = '';
    let supportContactMarkUp = '';

    if (!!props.waitingArea.supportSetting) {
      supportName = props.waitingArea.supportSetting.isResetRequest
        ? props.waitingArea.supportSetting.organisaionSupportName || 'Not provided'
        : props.waitingArea.supportSetting.supportName || 'Not provided';
      let supportEmailAddress = props.waitingArea.supportSetting.isResetRequest
        ? 'mailto:' + props.waitingArea.supportSetting.organisaionSupportEmail
        : 'mailto:' + props.waitingArea.supportSetting.supportEmail;
      supportEmail = props.waitingArea.supportSetting.isResetRequest
        ? props.waitingArea.supportSetting.organisaionSupportEmail || 'Not provided'
        : props.waitingArea.supportSetting.supportEmail || 'Not provided';
      supportPhone = props.waitingArea.supportSetting.isResetRequest
        ? props.waitingArea.supportSetting.organisaionSupportPhone || 'Not provided'
        : props.waitingArea.supportSetting.supportPhone || 'Not provided';
      supportWebsite = props.waitingArea.supportSetting.isResetRequest
        ? props.waitingArea.supportSetting.organisaionSupportWebsite || 'Not provided'
        : props.waitingArea.supportSetting.supportWebsite || 'Not provided';

      return (
        <div>
          {supportName === 'Not provided' ? '' : <div>{supportName}</div>}
          {supportEmail === 'Not provided' ? (
            ''
          ) : (
            <div>
              <a href={supportEmailAddress}>{supportEmail}</a>
            </div>
          )}
          {supportPhone === 'Not provided' ? '' : <div>{supportPhone}</div>}
          {supportWebsite === 'Not provided' ? '' : <div>{supportWebsite}</div>}
        </div>
      );
    }
    return '';
  };

  const getInfomrationForCallers = () => {
    if (!!props.waitingArea.supportSetting) {
      return (
        <div>
          <div>
            {(props.waitingArea.moreAssistanceSetting && props.waitingArea.moreAssistanceSetting.moreAssistance) ||
              'Not provided'}
          </div>
          <div className="mrtm">{generatePILDownloadButton()}</div>
        </div>
      );
    }
    return <div>{generatePILDownloadButton()}</div>;
  };

  const generateURLToUserMarkUp = () => {
    let infoPartThree = '';
    let infoPartFour = '';
    let shareURLMarkup = '';
    if (props.waitingArea && props.waitingArea.callEntryPageUrl) {
      infoPartThree = APP.LANGUAGE.ViewWaitingArea.InfoPartThree;
      infoPartFour = APP.LANGUAGE.ViewWaitingArea.InfoPartFour.split('##callEntryPageUrl##').join(
        props.waitingArea.callEntryPageUrl
      );
      shareURLMarkup = (
        <button type="button" className="ui labeled icon button right-hand-side-button">
          <i id="share-url-icon" className="icon share external" />
          {APP.LANGUAGE.ViewWaitingArea.ShareURL}
        </button>
      );
    }
    return (
      <div>
        <div className="mrbs">
          <span className="color-info mrtm">{htmlToReactParser.parse(xss(infoPartFour))}</span>
        </div>
        <Dropdown
          trigger={shareURLMarkup}
          icon="caret down"
          id="share-wa-url"
          upward={false}
          className="inline-flex center-flex space-between full-height bold color-bad-things-text"
          onOpen={() => {
            setExtendContent(true);
          }}
          onClose={() => {
            setExtendContent(false);
          }}
        >
          <Dropdown.Menu className="max-width" id="share-url-submenu">
            <Dropdown.Item
              className="inline-flex max-width text-message-piwa"
              onClick={() => {
                let cb = (result) => {
                  if (result) {
                    dispatch(showShareByTextModal(true));
                  }
                };
                dispatch(getWAURLTextTemplate(props.waitingArea.id, cb));
              }}
            >
              <Icon name="mobile alternate" />
              <span className="text">{APP.LANGUAGE.ViewWaitingArea.ShareByText}</span>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                let cb = (result) => {
                  if (result) {
                    dispatch(showShareByEmailModal(true));
                  }
                };
                dispatch(getWAURLEmailTemplate(props.waitingArea.id, cb));
              }}
            >
              <Icon name="envelope" />
              <span className="text">{APP.LANGUAGE.ViewWaitingArea.ShareByEmail}</span>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                copy(props.waitingArea.callEntryPageUrl);
                dispatch(
                  displayGlobalMessage({
                    text: APP.LANGUAGE.ShareURL.URLCopied,
                    visible: true,
                    messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
                    autoHide: true,
                  })
                );
              }}
            >
              <div>
                <Icon name="copy" />
                <span className="text">{APP.LANGUAGE.ViewWaitingArea.InfoCopyUrlButton}</span>
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        {extendContent ? <div className="extend-height" /> : ''}
      </div>
    );
  };

  let aboutThisPageMarkup = (
    <div>
      <i className="ui icon info circle mrls mrrnull text-size-xl fr mrbs" />
      <p>{htmlToReactParser.parse(xss(APP.LANGUAGE.ViewWaitingArea.InfoPartOne))}</p>
      <p>{htmlToReactParser.parse(xss(APP.LANGUAGE.ViewWaitingArea.InfoPartTwo))}</p>
    </div>
  );

  let options = [
    {
      title: 'Waiting Area hours',
      as: 'custom',
      content: generateWAhoursMarkUp(),
    },
    {
      title: 'Test My equipment',
      as: 'testCallBtn',
      link: `ce/?apikey=${
        props.waitingArea.orgAPIKey || window.APP.CONFIGURATION.DEFAULT_ORGANISATION_APIKEY
      }&testonly=true`,
    },
    {
      title: 'Waiting Area link',
      as: 'custom',
      content: generateURLToUserMarkUp(),
    },
    {
      title: 'Information for Callers',
      as: 'custom',
      content: getInfomrationForCallers(),
    },
    {
      title: 'Support contact for staff',
      as: 'custom',
      content: generateSupportContactDetail(),
    },
    {
      title: 'About this page',
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  let consultNowOptions = [
    {
      title: 'Waiting Area hours',
      as: 'custom',
      content: generateWAhoursMarkUp(),
    },
    {
      title: 'Support contact for staff',
      as: 'custom',
      content: generateSupportContactDetail(),
    },
  ];
  let gcOptions = [
    {
      title: 'Waiting Area hours',
      as: 'custom',
      content: generateWAhoursMarkUp(),
    },
    {
      title: 'Test My equipment',
      as: 'testCallBtn',
      link: `ce/?apikey=${
        props.waitingArea.orgAPIKey || window.APP.CONFIGURATION.DEFAULT_ORGANISATION_APIKEY
      }&testonly=true&gc=true`,
    },
    {
      title: 'Waiting Area link',
      as: 'custom',
      content: generateURLToUserMarkUp(),
    },
    {
      title: 'Information for Callers',
      as: 'custom',
      content: getInfomrationForCallers(),
    },
    {
      title: 'Support contact for staff',
      as: 'custom',
      content: generateSupportContactDetail(),
    },
    {
      title: 'About this page',
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  let activeIndexOfPage =
    props.isConsultNowEnabled && props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase()
      ? window.localStorage.getItem(`piwaConsultNowActiveIndex-${props.userId}`)
      : window.localStorage.getItem(`piwaActiveIndex-${props.userId}`);

  return (
    <BottomAccordion
      options={
        props.isConsultNowEnabled && props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase()
          ? consultNowOptions
          : props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation
          ? gcOptions
          : options
      }
      className="dark-accordion-divider"
      boldTitle={true}
      renderTestCallBtn={true}
      userId={props.userId}
      pagePrefix={
        props.isConsultNowEnabled && props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase()
          ? 'piwaConsultNowActiveIndex'
          : 'piwaActiveIndex'
      }
      activeIndex={
        props.isConsultNowEnabled && props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase()
          ? (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
              consultNowOptions[0].title.split(' ').join(''),
              consultNowOptions[1].title.split(' ').join(''),
              consultNowOptions[consultNowOptions.length - 1].title.split(' ').join(''),
            ]
          : (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
              options[0].title.split(' ').join(''),
              options[1].title.split(' ').join(''),
              options[2].title.split(' ').join(''),
              options[3].title.split(' ').join(''),
              options[options.length - 1].title.split(' ').join(''),
            ]
      }
    />
  );
}
